<template>
  <el-dialog
    title="蓝海行动报名资料"
    :visible.sync="dialogVisible"
    width="700px"
    center
    @close="$refs['blueSeaParticipateInfoform'].resetFields();$emit('close',dialogVisible)">
    <div v-loading="loading">
      <!-- 蓝海行动资料相关 -->
      <div>
        <el-form ref="blueSeaParticipateInfoform" :model="form" :rules="formRules" label-width="100px" label-position="left">
          <h4>证照信息</h4>
          <el-form-item label-width="0">
            <el-col :span="11">
              <el-form-item prop="cashierDeskForAliPay">
                <upload-img-ele v-model="form.cashierDeskForAliPay" valueName="cashierDeskForAliPay" label="收银台照(含支付宝相关物料)" @upload="uploadSuccess"></upload-img-ele>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item prop="thirdPlatformSettledPic">
                <upload-img-ele v-model="form.thirdPlatformSettledPic" valueName="thirdPlatformSettledPic" label="第三方平台入驻照" @upload="uploadSuccess"></upload-img-ele>
              </el-form-item>
            </el-col>
          </el-form-item>
        </el-form>
        <div class="red-tip">备注:若商户信息中无营业执照请先补齐再申请参加蓝海行动，营业执照为蓝海行动必须资料</div>
      </div>
    </div>
    <span slot="footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="submit">提 交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import qs from 'qs'
import UploadImgEle from '../../../components/upload/uploadImgEle'
import { updateDetailInfo } from '@/api/merchant'
export default {
  name: 'JoinBlueSea',
  components: {
    UploadImgEle
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    }
  },
  watch: {
    visible (val) {
      this.dialogVisible = val
    }
  },
  data () {
    return {
      dialogVisible: false,
      loading: false,
      form: {
        merchantId: '',
        cashierDeskForAliPay: '',
        thirdPlatformSettledPic: ''
      },
      formRules: {
        cashierDeskForAliPay: [
          { required: true, message: '请上传收银台照' }
        ],
        thirdPlatformSettledPic: [
          { required: true, message: '请上传第三方平台入驻照' }
        ]
      }
    }
  },
  mounted () {
    this.dialogVisible = this.visible
    this.form.merchantId = this.id
  },
  methods: {
    /**
             * @description 图片上传成功的回调
             * @param {Object} data 回调数据对象
             */
    uploadSuccess (data) {
      const name = data.valueName
      this.form[name] = data.path
    },
    /**
             * @description 点击取消
             */
    cancel () {
      this.$confirm('请确认是否放弃当前修改内容', '提示', {
        type: 'warning'
      }).then(() => {
        this.dialogVisible = false
      })
    },
    /**
             * @description 点击提交
             */
    submit () {
      this.$refs.blueSeaParticipateInfoform.validate(valid => {
        if (valid) {
          this.$confirm('请确认是否提交审核', '提示', {
            type: 'warning'
          }).then(async () => {
            await this.updateInfo()
            this.dialogVisible = false
            this.$emit('submit', true)
          })
        } else {
          console.log('error submit!!')
          this.$message({
            message: '提交信息有误，请完善后重新提交',
            type: 'error'
          })
          return false
        }
      })
    },
    /**
             * @description 更新蓝海信息
             */
    updateInfo () {
      return new Promise((resolve, reject) => {
        this.loading = true
        const params = qs.stringify(this.form)
        updateDetailInfo(params).then(response => {
          this.loading = false
          if (response.error_code === '0') {
            this.$message({
              message: '资料提交成功',
              type: 'success'
            })
          } else {
            this.$message({
              message: response.error_msg,
              type: 'error'
            })
          }
        })
      })
    }
  }
}
</script>

<style scoped>

</style>
